import { GlobalResponseObject } from "@gtpl/shared-models/common-models";

export class ReWeighMentViewResponseModel extends GlobalResponseObject {
    data?: any;
    data1?:any
    

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: any,data1?:any){
        super(status, intlCode, internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
        this.data1 = data1
        

    }
}
